<template>
  <div class="wrapper">
    <div class="intro">
      <h2 v-html="$t('pages.vehicles.heading')" />
      <h2
        class="subtitle"
        v-html="$t('pages.vehicles.heading_subtitle')"
      />
      <p
        class="text"
        v-html="$t('pages.vehicles.description')"
      />
    </div>
    <vehicle-list />
  </div>
</template>
<script>

export default {
  name: 'VehiclesLayout',
  components: {
    VehicleList: () => import(/* webpackChunkName: "vehicle"  */ `./VehicleList`),
  },
}
</script>
<style scoped lang="scss">
@import "../../../../_src/sass/config/vars";
@import "../../../../_src/sass/config/mixins";
@import "../../../../_src/sass/config/responsive";

.intro {
  color: $c-tundora;
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 20px 20px;

  @include teq-breakpoint($wide) {
    margin: auto;
    max-width: calc(100% - 186px);
  }

  .text {
    font-family: $f-graphie-book;
    font-size: 14px;
    font-style: normal;
    font-weight: normal;
    line-height: 20px;
    text-align: center;
  }

  h1 {
    font-family: $f-graphie-bold;
    font-size: 40px;
    text-transform: lowercase;
  }

  h2 {
    font-family: $f-graphie-extrabold;
    font-size: 48px;
    line-height: 48px;
    margin-bottom: 0;
    padding-top: 2.5rem;

    @include teq-breakpoint($wide) {
      font-size: 72px;
      line-height: 72px;
    }
  }

  .subtitle {
    font-family: $f-graphie-bold;
    font-size: 32px;
    line-height: 38.4px;
    margin-bottom: 7rem;
    margin-top: 0;

    @include teq-breakpoint($wide) {
      font-size: 40px;
      line-height: 48px;
    }
  }
}

</style>
